import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";

export interface GlobalSettings {
  zalo_url: string;
  facebook_url: string;
  website_url: string;
  hotline: string;
}

const DEFAULTS: GlobalSettings = {
  zalo_url: "https://zalo.me/0965180170",
  facebook_url: "https://www.facebook.com/Bizwellcompany",
  website_url: "https://bizwell.com.vn",
  hotline: "+84 965 180 170",
};

let cached: GlobalSettings | null = null;
let promise: Promise<GlobalSettings | null> | null = null;

const fetchSettings = async (): Promise<GlobalSettings | null> => {
  const { data, error } = await supabase
    .from("global_settings")
    .select("*")
    .limit(1)
    .maybeSingle();
  if (error || !data) return null;
  return {
    zalo_url: data.zalo_url || DEFAULTS.zalo_url,
    facebook_url: data.facebook_url || DEFAULTS.facebook_url,
    website_url: data.website_url || DEFAULTS.website_url,
    hotline: data.hotline || DEFAULTS.hotline,
  };
};

export const useGlobalSettings = () => {
  const [settings, setSettings] = useState<GlobalSettings>(cached ?? DEFAULTS);
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    const handleUpdate = () => {
      setSettings(cached ?? DEFAULTS);
    };
    window.addEventListener(GLOBAL_SETTINGS_EVENT, handleUpdate);
    return () => window.removeEventListener(GLOBAL_SETTINGS_EVENT, handleUpdate);
  }, []);

  useEffect(() => {
    if (cached) {
      setSettings(cached);
      setLoading(false);
      return;
    }
    if (!promise) {
      promise = fetchSettings();
    }
    promise.then((data) => {
      if (data) {
        cached = data;
        setSettings(data);
      }
      setLoading(false);
    });
  }, []);

  return { settings, loading };
};

export const getGlobalSettings = (): GlobalSettings => cached ?? DEFAULTS;

const GLOBAL_SETTINGS_EVENT = "global-settings-updated";

export const refreshGlobalSettings = async (): Promise<GlobalSettings> => {
  const data = await fetchSettings();
  if (data) {
    cached = data;
    window.dispatchEvent(new Event(GLOBAL_SETTINGS_EVENT));
    return data;
  }
  return DEFAULTS;
};